// Desktop first
// If you prefer mobile first than change max-width to min-width and rotate values in styles

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '440px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
}

export const device = {
  mobileS: `@media (max-width: ${size.mobileS})`,
  mobileM: `@media (max-width: ${size.mobileM})`,
  mobileL: `@media (max-width: ${size.mobileL})`,
  tablet: `@media (max-width: ${size.tablet})`,
  laptop: `@media (max-width: ${size.laptop})`,
  laptopL: `@media (max-width: ${size.laptopL})`,
  desktop: `@media (max-width: ${size.desktop})`,
  desktopL: `@media (max-width: ${size.desktop})`
};

export const mobileSmall = device.mobileS;
export const mobileMedium = device.mobileM;
export const mobileLarge = device.mobileL;
export const tablet = device.tablet;
export const laptopNormal = device.laptop;
export const laptopLarge = device.laptopL;
export const desktopNormal = device.desktop;
export const desktopLarge = device.desktopL;

